import React, { useState, useEffect } from 'react';
import { http } from '../../lib/api';
import { 
  Search, 
  Filter, 
  MessageSquare, 
  Clock, 
  CheckCircle, 
  AlertCircle, 
  User,
  RefreshCw,
  ChevronDown
} from 'lucide-react';
import OrdenDetalleModal from '../ordenes/OrdenDetalleModal';

export default function TicketsListAdmin() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ticketSeleccionado, setTicketSeleccionado] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState('pendiente'); // Por defecto ver pendientes

  useEffect(() => {
    cargarTickets();
  }, [filtroEstado]);

  const cargarTickets = async () => {
    setLoading(true);
    try {
      // Usar endpoint de tickets real
      const url = `/tickets?estado=${filtroEstado === 'todos' ? '' : filtroEstado}`;
      const res = await http.get(url);
      setTickets(res.data || []);
    } catch (err) {
      console.error('Error cargando tickets:', err);
      setError('Error al cargar los tickets de soporte');
    } finally {
      setLoading(false);
    }
  };

  const getPrioridadBadge = (prioridad) => {
    const colors = {
      alta: 'bg-red-100 text-red-800',
      media: 'bg-yellow-100 text-yellow-800',
      baja: 'bg-green-100 text-green-800'
    };
    return (
      <span className={`px-2 py-0.5 rounded text-xs font-medium uppercase ${colors[prioridad] || colors.media}`}>
        {prioridad || 'media'}
      </span>
    );
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Tickets de Soporte</h1>
          <p className="text-gray-600">Gestión de solicitudes de servicio</p>
        </div>
        <button 
          onClick={cargarTickets}
          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <RefreshCw size={20} />
        </button>
      </div>

      {/* Filtros */}
      <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6 flex gap-4">
        <div className="flex items-center gap-2">
          <Filter size={18} className="text-gray-400" />
          <select 
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
            className="border-none bg-transparent focus:ring-0 text-sm font-medium text-gray-700"
          >
            <option value="pendiente">Pendientes</option>
            <option value="en_proceso">En Proceso</option>
            <option value="resuelto">Resueltos / Completados</option>
            <option value="todos">Todos</option>
          </select>
        </div>
      </div>

      {/* Lista */}
      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
        </div>
      ) : tickets.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
          <MessageSquare className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-900">No hay tickets en esta vista</h3>
          <p className="text-gray-500">Intente cambiar los filtros</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {tickets.map(ticket => (
            <div 
              key={ticket._id || ticket.id}
              onClick={() => setTicketSeleccionado(ticket)}
              className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow cursor-pointer flex items-start gap-4"
            >
              <div className={`p-3 rounded-full shrink-0 ${
                ticket.estado === 'pendiente' ? 'bg-red-50 text-red-600' :
                ticket.estado === 'en_proceso' ? 'bg-emerald-50 text-emerald-600' :
                'bg-emerald-50 text-emerald-600'
              }`}>
                {ticket.estado === 'pendiente' ? <AlertCircle size={24} /> :
                 ticket.estado === 'en_proceso' ? <Clock size={24} /> :
                 <CheckCircle size={24} />}
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-semibold text-gray-900 truncate">
                    {ticket.equipo_descripcion || ticket.equipo_nombre || 'Equipo General'} - {ticket.sucursal || 'Sin sucursal'}
                  </h3>
                  <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                    {ticket.fecha_creacion ? new Date(ticket.fecha_creacion).toLocaleDateString() : 'N/A'}
                  </span>
                </div>
                
                <p className="text-gray-600 text-sm line-clamp-2 mb-2">
                  {ticket.descripcion_problema || 'Sin descripción'}
                </p>
                
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <User size={14} />
                    {ticket.cliente_nombre || ticket.nombre_cliente || 'N/A'}
                  </span>
                  {getPrioridadBadge(ticket.prioridad)}
                  <span className="uppercase font-medium tracking-wide">
                    #{ticket.numero_ticket || ticket.numero_orden || 'S/N'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {ticketSeleccionado && (
        <OrdenDetalleModal
          orden={ticketSeleccionado}
          onClose={() => setTicketSeleccionado(null)}
          onUpdate={cargarTickets}
        />
      )}
    </div>
  );
}
